export default "__VITE_ASSET__DUbztLx2__"